export enum AvailabilityType {
  Reservation,
  Takeaway,
}
